import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const QUEUE = "btp_pending_completions";

export function registerSW() {
  if ("serviceWorker" in navigator) navigator.serviceWorker.register("/sw.js").catch(() => {});
}

export function clearApiCache() {
  navigator.serviceWorker?.controller?.postMessage("clear-api-cache");
}

export async function prefetchOffline() {
  if (!navigator.onLine) return;
  try {
    const [hist] = await Promise.all([api.get("/lessons/history"), api.get("/vocabulary"), api.get("/lessons/today"), api.get("/progress")]);
    await Promise.all(hist.data.slice(0, 5).map((l) => api.get(`/lessons/${l.id}`).catch(() => {})));
  } catch {
    /* best effort */
  }
}

const readQueue = () => JSON.parse(localStorage.getItem(QUEUE) || "[]");

export function queueCompletion(lessonId, answers) {
  const q = readQueue().filter((x) => x.lessonId !== lessonId);
  localStorage.setItem(QUEUE, JSON.stringify([...q, { lessonId, answers }]));
}

export const pendingCount = () => readQueue().length;

export async function flushQueue() {
  const q = readQueue();
  if (!q.length || !navigator.onLine) return 0;
  const left = [];
  let sent = 0;
  for (const item of q) {
    try {
      await api.post(`/lessons/${item.lessonId}/complete`, { answers: item.answers });
      sent += 1;
    } catch (e) {
      if (!e.response) left.push(item);
    }
  }
  localStorage.setItem(QUEUE, JSON.stringify(left));
  return sent;
}

export function useOnline() {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);
  return online;
}
